module.exports = __webpack_public_path__ + "static/media/tree-christmas.fd79e08e.svg";